module.exports = __webpack_public_path__ + "18b34e180d07394348bfb33d4a2cd0e8.png";